export interface MarkdownImageTitle {
	title?: string;
	width?: number;
	height?: number;
}

const MAX_IMAGE_DIMENSION = 4096;
const SIZE_TOKEN_PATTERN = /\b(width|height)=(\d{1,5})\b/g;

function normalizeDimension(value: unknown): number | undefined {
	const parsed =
		typeof value === "number"
			? value
			: typeof value === "string"
				? Number.parseInt(value, 10)
				: Number.NaN;

	if (Number.isFinite(parsed) && parsed > 0 && parsed <= MAX_IMAGE_DIMENSION) {
		return Math.round(parsed);
	}

	return undefined;
}

export function parseMarkdownImageTitle(
	rawTitle: string | null | undefined,
): MarkdownImageTitle {
	const source = rawTitle?.trim();
	if (!source) return {};

	let width: number | undefined;
	let height: number | undefined;

	for (const match of source.matchAll(SIZE_TOKEN_PATTERN)) {
		const [, key, value] = match;
		if (key === "width") {
			width = normalizeDimension(value);
		}
		if (key === "height") {
			height = normalizeDimension(value);
		}
	}

	const title = source
		.replace(SIZE_TOKEN_PATTERN, "")
		.replace(/\s+/g, " ")
		.trim();

	return {
		title: title || undefined,
		width,
		height,
	};
}
